import React from 'react';
import PropTypes from 'prop-types';
import { generateImageSource } from '../../../utils/generateImageSource';

export const RelocationSection = ({ readyToRelocate, commuteDistance }) => {

  const distanceText = {
    'less than 5 miles': '< 5 miles',
    'up to 10 miles': '< 10 miles',
    'up to 25 miles': '< 25 miles',
    '50 miles or more': '> 50 miles'
  };

  return (
    <section className="ptp-relocation">
      {commuteDistance
      && (
        <span className="ptp-relocation__row">
          <img
            src={generateImageSource('/images/v1/path-to-pro/radius-icon.svg')}
            className="ptp-relocation__radius-icon"
          />
          Work Radius: {distanceText[commuteDistance]}
        </span>
      )}
      <div />
      {readyToRelocate ? 'Willing to Relocate' : ''}
    </section>
  );
};

RelocationSection.propTypes = {
  readyToRelocate: PropTypes.bool,
  commuteDistance: PropTypes.string
};

RelocationSection.defaultProps = {
  readyToRelocate: false,
  commuteDistance: ''
};
